// extracted by mini-css-extract-plugin
export default {"root":"fK1C2PDLABRqx6w15Xxk","logo":"YinxMhvBs1ZVzlTL38Gt"};